import { ShoppingPaymentStatusId } from 'v2/interfaces/shopping';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';

export const updateDeliveryStatus = (delivery: ShoppingDelivery) => {
  let status = delivery.payment_status;

  if (!delivery?.bankslip_installments?.installments?.length) {
    return status;
  }

  const installments = delivery.bankslip_installments.installments;

  const allPaid = installments.every((inst) => inst.payment_status.id === ShoppingPaymentStatusId.PAGA);

  if (allPaid) {
    return status;
  }

  const hasOpen = installments.some((inst) => inst.payment_status.id === ShoppingPaymentStatusId.ABERTA);

  if (hasOpen) {
    return {
      id: ShoppingPaymentStatusId.ABERTA,
      name: 'Em andamento',
      alias: 'open',
    };
  }

  const firstUnpaid = installments.find((inst) => inst.payment_status.id !== ShoppingPaymentStatusId.PAGA);

  return firstUnpaid
    ? {
        id: firstUnpaid.payment_status.id,
        name: firstUnpaid.payment_status.name,
        alias: firstUnpaid.payment_status.alias,
      }
    : status;
};
